import React from 'react';
import { OPCUATreePage } from '@cedalo/opcua-webui-components';

export function PluginExtensions(props) {
	return <div>{props.location.pathname === '/administration/plugins/opcua' ? <OPCUATreePage /> : null}</div>;
}



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/PluginExtensions.js